import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import BundleCard from "@/components/BundleCard";

const GROUP_ORDER = ["Research Bundles", "Reconstitution Kits"];
const GROUP_META = {
  "Research Bundles": {
    testid: "bundles-research-bundles",
    tag: "Multi-compound research bundles",
  },
  "Reconstitution Kits": {
    testid: "bundles-reconstitution-kits",
    tag: "Pre-bundled supplies",
  },
};

export default function Bundles() {
  const { data: bundles = [] } = useQuery({
    queryKey: ["bundles"],
    queryFn: async () => (await api.get("/bundles")).data,
  });

  if (bundles.length === 0) return null;

  const grouped = bundles.reduce((acc, b) => {
    const g = b.group || "Research Bundles";
    (acc[g] ||= []).push(b);
    return acc;
  }, {});

  return (
    <section id="bundles" className="border-b border-line" data-testid="bundles-section">
      <div className="container-pd py-16 lg:py-24">
        <p className="label-mono text-brandblue">↳ Bundles</p>
        <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Research Bundles
        </h2>
        <p className="mt-3 max-w-xl text-base text-subtle">
          Multi-compound research bundles group separately supplied research
          materials into one order, plus pre-packed laboratory-preparation
          supply kits.
        </p>

        {GROUP_ORDER.filter((g) => grouped[g]?.length).map((group) => (
          <div key={group} className="mt-12" data-testid={GROUP_META[group].testid}>
            <div className="mb-5 flex items-baseline justify-between">
              <h3 className="font-heading text-xl font-black text-ink">{group}</h3>
              <span className="font-mono text-[10px] tracking-[0.18em] text-subtle">
                {GROUP_META[group].tag.toUpperCase()}
              </span>
            </div>
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
              {grouped[group].map((b) => (
                <BundleCard key={b.id} bundle={b} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
